import React from "react";
import { NavLink } from "react-router-dom";

import AuthenticationButton from "./AuthenticationButton";

const NavigationBar = () => {
  return (
    <div className="nav-container mb-3">
      <nav className="navbar navbar-expand-md navbar-light bg-light">
        <div className="container">
          <NavLink to="/" className="nav-link">
            <div className="navbar-brand logo">Formful</div>
          </NavLink>

          <div className="d-flex">
            <div
              className="navbar-nav"
              style={{
                marginRight: "1rem",
              }}
            >
              <NavLink
                to="/"
                exact
                className="nav-link"
                activeClassName="router-link-exact-active"
              >
                Home
              </NavLink>

              <NavLink
                to="/createForm"
                exact
                className="nav-link"
                activeClassName="router-link-exact-active"
              >
                Create Form
              </NavLink>
            </div>

            <AuthenticationButton />
          </div>
        </div>
      </nav>
    </div>
  );
};

export default NavigationBar;
